const TEST_IDS = {
  selectTokenTextField: 'supply-modal-select-token-text-field',
  tokenTextField: 'supply-modal-token-text-field',
  submitButton: 'submit-button',
  noticeError: 'notice-error',
  noticeAssetWarning: 'notice-isolated-asset',
  spendingLimit: 'spending-limit',
};

export default TEST_IDS;
